import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, BookOpen, Briefcase, GraduationCap, Award, Users, ExternalLink, Home, Loader } from 'lucide-react';
import LanguagePicker, { useTranslation, t } from '../components/LanguagePicker';
import axios from 'axios';
import '../styles/author.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AUTHORS = [
  {
    slug: 'heru-muara-sidik',
    name: 'H. Heru Muara Sidik, Ak., CMA., CA., M.M., QIA.',
    shortName: 'Heru Muara Sidik',
    title: 'Anggota Dewan Pengawas BPKH',
    titleEn: 'Supervisory Board Member, BPKH',
    photo: 'https://bpkh.go.id/storage/uploads/2016/06/Heru-Muara-Sidik-1.png',
    bpkhUrl: 'https://bpkh.go.id/tentang-bpkh/biodata/dewan-pengawas/heru-muara-sidik',
    domicile: 'DKI Jakarta',
    period: '2022-2027',
    affiliations: ['BPKH (Badan Pengelola Keuangan Haji)', 'Dewan Sertifikasi QIA'],
    education: [
      { degree: 'Magister Manajemen (M.M.) Keuangan', institution: 'Telkom University', year: '2014-2016' },
      { degree: 'D4 Akuntansi', institution: 'Sekolah Tinggi Akuntansi Negara (STAN)', year: '1989-1992' },
      { degree: 'D3 Akuntansi', institution: 'Sekolah Tinggi Akuntansi Negara (STAN)', year: '1983-1986' },
    ],
    career: [
      { role: 'Anggota Dewan Pengawas', org: 'BPKH', period: '2022-sekarang' },
      { role: 'Ketua Komite Pengujian dan Kelulusan', org: 'Dewan Sertifikasi QIA', period: 'November 2021-Oktober 2022' },
      { role: 'Executive Director', org: 'The Center of Internal Audit Resources', period: 'Juni 2022-Oktober 2022' },
      { role: 'Advisory Board Member', org: 'Forum Komunikasi Satuan Pengawasan Internal', period: 'Juli 2019-sekarang' },
    ],
    expertise: ['Governance', 'Internal Audit', 'Accounting', 'Sharia-Compliant Investment', 'Financial Management', 'Digital Transformation'],
    bio: 'H. Heru Muara Sidik adalah Anggota Dewan Pengawas BPKH periode 2022-2027, diangkat berdasarkan Keputusan Presiden RI No. 101/P Tahun 2022. Warga negara Indonesia berdomisili di DKI Jakarta. Seorang auditor terlatih dan strategis berpengalaman, karya hidupnya berpusat pada memastikan bahwa kepercayaan publik tidak hanya dikelola, tetapi dihormati. Dari formasi awalnya di STAN hingga perannya sebagai Anggota Dewan Pengawas BPKH, Heru telah berdiri di persimpangan antara tata kelola dan pelayanan nasional. Pengalamannya dalam audit internal dan investasi yang sesuai syariah telah membentuk keyakinannya bahwa transformasi digital harus disertai dengan disiplin etis. Tidak memiliki hubungan afiliasi dengan Anggota Badan Pelaksana dan Anggota Dewan Pengawas lainnya.',
    quote: 'Membawa disiplin seorang auditor, visi seorang strategis, dan kerendahan hati seorang pemimpin pelayan.',
  },
  {
    slug: 'harry-alexander',
    name: 'Harry Alexander, S.H., M.H., LL.M.',
    shortName: 'Harry Alexander',
    title: 'Anggota Badan Pelaksana BPKH (Penghimpunan, Transformasi dan TI)',
    titleEn: 'Executive Board Member, BPKH (Collection, Transformation & IT)',
    photo: 'https://bpkh.go.id/storage/uploads/2024/11/Harry-Alexander.png',
    bpkhUrl: 'https://bpkh.go.id/tentang-bpkh/biodata/badan-pelaksana/harry-alexander',
    domicile: 'Tangerang Selatan',
    period: '2022-2027',
    affiliations: ['BPKH (Badan Pengelola Keuangan Haji)', 'World Bank Group / IFC'],
    education: [
      { degree: 'LL.M. Hukum Energi, Sumberdaya Alam, Lingkungan dan Internasional', institution: 'Northwestern School of Law of Lewis & Clark College, Portland, USA', year: '2008' },
      { degree: 'Magister Hukum (M.H.) Hukum Bisnis', institution: 'Fakultas Hukum Universitas Indonesia', year: '2006' },
      { degree: 'Sarjana Hukum (S.H.) Hukum Internasional', institution: 'Fakultas Hukum Universitas Indonesia', year: '2001' },
    ],
    career: [
      { role: 'Anggota Badan Pelaksana (Penghimpunan, Transformasi dan TI)', org: 'BPKH', period: '2022-sekarang' },
      { role: 'Deputi Hukum dan Kepatuhan', org: 'BPKH', period: '2019-2022' },
      { role: 'Deputi Hukum dan Pengembangan', org: 'BPKH', period: '2020-2021' },
      { role: 'Kepala Divisi Manajemen Risiko', org: 'Sekretariat KSSK, Kementerian Keuangan', period: '2019' },
      { role: 'Kepala Divisi Koordinasi Stabilitas Sistem Keuangan', org: 'Lembaga Penjamin Simpanan (LPS)', period: '2018-2019' },
      { role: 'Kepala Divisi Pengembangan Kebijakan', org: 'Lembaga Penjamin Simpanan (LPS)', period: '2016-2018' },
      { role: 'Kepala Divisi Peraturan', org: 'Lembaga Penjamin Simpanan (LPS)', period: '2014' },
      { role: 'Penasihat Regulasi, Grup Iklim Investasi', org: 'IFC, World Bank Group', period: '2010-2014' },
      { role: 'Penasihat Transaksi, Grup Kemitraan Publik-Swasta', org: 'IFC, World Bank Group', period: '2012-2014' },
      { role: 'Asisten Direktur Regulasi dan Kebijakan', org: 'Wildlife Conservation Society, New York', period: '2003-2010' },
      { role: 'Penasihat Hukum, Program ICDP', org: 'IBRD, World Bank', period: '2000-2003' },
      { role: 'ICDP-World Bank', org: 'IBRD, World Bank', period: '1999-2002' },
    ],
    expertise: ['Law & Investment', 'International Partnerships', 'Public-Private Partnerships', 'Risk Management', 'Energy & Environmental Law', 'Sharia Compliance'],
    bio: 'Harry Alexander, S.H., M.H., LL.M. adalah Anggota Badan Pelaksana BPKH yang membidangi fungsi Penghimpunan, Transformasi dan Teknologi Informasi, periode 2022-2027, diangkat berdasarkan Keputusan Presiden RI No. 101/P Tahun 2022. Warga negara Indonesia berdomisili di Tangerang Selatan. Dengan pelatihan hukum di Universitas Indonesia dan LL.M. dari Lewis & Clark College USA, Harry memiliki pengalaman internasional yang luas termasuk sebagai Penasihat di World Bank Group (IFC) dan Asisten Direktur di Wildlife Conservation Society New York. Karyanya dalam kemitraan publik-swasta dan hukum investasi memposisikannya sebagai jembatan antara institusi Indonesia dan komunitas investasi global. Tidak memiliki hubungan afiliasi dengan Anggota Dewan Pengawas dan Anggota Badan Pelaksana lainnya.',
    quote: 'Menawarkan perspektif seorang ahli hukum dan pragmatisme seorang negosiator.',
  },
  {
    slug: 'indra-gunawan',
    name: 'Dr. H. Indra Gunawan, S.E., S.IP., M.Sc., CIMBA., CIB., CPM., CSA., ACiArb., CRP.',
    shortName: 'Indra Gunawan',
    title: 'Anggota Badan Pelaksana BPKH (Investasi Surat Berharga dan Emas)',
    titleEn: 'Executive Board Member, BPKH (Securities & Gold Investment)',
    photo: 'https://bpkh.go.id/storage/uploads/2024/11/Indra-Gunawan.png',
    bpkhUrl: 'https://bpkh.go.id/tentang-bpkh/biodata/badan-pelaksana/indra-gunawan',
    domicile: 'DKI Jakarta',
    period: '2022-2027',
    affiliations: ['BPKH (Badan Pengelola Keuangan Haji)', 'IPB University', 'Universitas Padjadjaran'],
    education: [
      { degree: 'S3 Doktor Manajemen Bisnis (D.M.B.)', institution: 'IPB University', year: '2020' },
      { degree: 'S2 Artificial Intelligence', institution: 'Universitas Nusa Putra', year: '' },
      { degree: 'S2 Law & Economics', institution: 'Utrecht University, Belanda', year: '2003' },
      { degree: 'S1 Ekonomi Studi Pembangunan', institution: 'Universitas Padjadjaran', year: '2001' },
      { degree: 'S1 Hubungan Internasional', institution: 'Universitas Pasundan', year: '2000' },
    ],
    career: [
      { role: 'Anggota Badan Pelaksana (Investasi Surat Berharga dan Emas, Analisis Portofolio, Penyelesaian Transaksi dan Penempatan)', org: 'BPKH', period: '2022-sekarang' },
      { role: 'Deputi Investasi Surat Berharga dan Emas', org: 'BPKH', period: '2020-2022' },
      { role: 'Deputi Investasi Surat Berharga dan Emas, Plt. Deputi TDTI dan PUM', org: 'BPKH', period: '2020-2021' },
      { role: 'Deputi Investasi', org: 'BPKH', period: '2018-2020' },
      { role: 'Kepala Pengelola Investasi', org: 'Aset Manajemen Indonesia', period: '2014-2018' },
      { role: 'Kepala Group Investasi, Tenaga Ahli/Spesialis', org: 'PT CIMB Sunlife', period: '2011-2014' },
      { role: 'Dosen Fakultas Ekonomi dan Bisnis', org: 'UIII & Universitas Padjadjaran', period: '2022-sekarang' },
      { role: 'Dosen', org: 'STM PPM Manajemen', period: '2015-sekarang' },
      { role: 'Dosen Peneliti/Pengajar/Pembimbing', org: 'Berbagai PTN/PTS di Indonesia', period: '2003-sekarang' },
      { role: 'Konsultan/Peneliti/Instruktur', org: 'Berbagai instansi', period: '2001-sekarang' },
    ],
    expertise: ['Securities & Gold Investment', 'Portfolio Analysis', 'Business Management', 'Artificial Intelligence', 'Law & Economics', 'Asset Management'],
    bio: 'Dr. H. Indra Gunawan, S.E., S.IP., M.Sc., CIMBA., CIB., CPM., CSA., ACiArb., CRP. adalah Anggota Badan Pelaksana BPKH yang membidangi fungsi Investasi Surat Berharga dan Emas, Analisis Portofolio, Penyelesaian Transaksi dan Penempatan, periode 2022-2027, diangkat berdasarkan Keputusan Presiden RI No. 101/P Tahun 2022. Warga negara Indonesia berdomisili di DKI Jakarta. Dengan akar akademis dalam ekonomi, hubungan internasional, dan hukum, serta doktor dalam manajemen bisnis dari IPB University, Indra mewujudkan keunggulan interdisipliner. Ia juga menempuh studi Artificial Intelligence dan Law & Economics di Utrecht University, Belanda. Tidak memiliki hubungan afiliasi dengan Anggota Dewan Pengawas dan Anggota Badan Pelaksana lainnya.',
    quote: 'Berdiri sebagai arsitek sekaligus navigator: seorang pemikir yang mampu memetakan wilayah baru.',
  },
  {
    slug: 'arif-mufraini',
    name: 'Prof. Dr. H. M. Arief Mufraini, Lc., M.Si.',
    shortName: 'Muhammad Arief Mufraini',
    title: 'Anggota Badan Pelaksana BPKH (Investasi Langsung, Riset & Pengembangan)',
    titleEn: 'Executive Board Member, BPKH (Direct Investment, Research & Development)',
    photo: 'https://bpkh.go.id/storage/uploads/2024/11/H.-M.-Arief-Mufraini.png',
    bpkhUrl: 'https://bpkh.go.id/tentang-bpkh/biodata/badan-pelaksana/arief-mufraini',
    domicile: 'Tangerang Selatan',
    period: '2022-2027',
    affiliations: ['BPKH (Badan Pengelola Keuangan Haji)', 'UIN Syarif Hidayatullah Jakarta', 'Universitas Al-Azhar Kairo'],
    education: [
      { degree: 'PhD Manajemen, Perbankan dan Keuangan (Sandwich Program)', institution: 'Universitas Padjadjaran & Kentucky University-Lexington, USA', year: '2012' },
      { degree: "Master's in Islamic Economics and Finance", institution: 'University of Indonesia', year: '2003' },
      { degree: 'Sarjana Double Degree Syariah dan Hukum', institution: 'Universitas Al-Azhar, Kairo, Mesir', year: '2000' },
    ],
    career: [
      { role: 'Anggota Badan Pelaksana (Investasi Langsung dan Investasi Lainnya, Perencanaan, Riset dan Pengembangan)', org: 'BPKH', period: '2022-sekarang' },
      { role: 'Guru Besar Bidang Ilmu Ekonomi Islam', org: 'UIN Syarif Hidayatullah Jakarta', period: '2022' },
      { role: 'Direktur Keuangan dan Pengembangan Bisnis', org: 'Syahida Foundation', period: '2019-2023' },
      { role: 'Dekan Fakultas Ekonomi dan Bisnis', org: 'UIN Syarif Hidayatullah Jakarta', period: '2015-2019' },
      { role: 'Kepala Sub Direktorat Pengelolaan dan Pengembangan Dana Haji', org: 'Kementerian Agama RI', period: '2013-2015' },
      { role: 'Kepala Program Studi Ekonomi Islam', org: 'UIN Syarif Hidayatullah Jakarta', period: '2012-2013' },
    ],
    expertise: ['Islamic Finance', 'Zakat Management', 'Sharia Governance', 'Direct Investment', 'Banking & Finance', 'Islamic Economics'],
    bio: 'Prof. Dr. H. M. Arief Mufraini, Lc., M.Si. adalah Anggota Badan Pelaksana BPKH yang membidangi fungsi Investasi Langsung dan Investasi Lainnya, Perencanaan, Riset dan Pengembangan, periode 2022-2027, diangkat berdasarkan Keputusan Presiden RI No. 101/P Tahun 2022. Warga negara Indonesia berdomisili di Tangerang Selatan. Beliau meraih gelar Sarjana ganda Syariah dan Hukum dari Universitas Al-Azhar Kairo, Mesir, serta PhD dari Universitas Padjadjaran dan Kentucky University-Lexington, USA. Sebagai Guru Besar Ekonomi Islam di UIN Syarif Hidayatullah Jakarta dan mantan Dekan Fakultas Ekonomi dan Bisnis. Tidak memiliki hubungan afiliasi dengan Anggota Dewan Pengawas dan Anggota Badan Pelaksana lainnya.',
    quote: 'Menjangkarkan ekosistem dalam pengabdian dan tujuan di dunia yang didorong data.',
  },
  {
    slug: 'mulyadi',
    name: 'Dr. H. Mulyadi, S.E., Akt., M.M., M.Si., CPMA., SAS., CA., QIA., QGIA.',
    shortName: 'Mulyadi',
    title: 'Anggota Dewan Pengawas BPKH',
    titleEn: 'Supervisory Board Member, BPKH',
    photo: 'https://bpkh.go.id/storage/uploads/2016/06/Mulyadi-1.png',
    bpkhUrl: 'https://bpkh.go.id/tentang-bpkh/biodata/dewan-pengawas/mulyadi',
    domicile: 'Cilegon',
    period: '2022-2027',
    affiliations: ['BPKH (Badan Pengelola Keuangan Haji)', 'Universitas Trisakti', 'Universitas Bhayangkara Jakarta Raya'],
    education: [
      { degree: 'Doktor Ilmu Ekonomi', institution: 'Universitas Trisakti Jakarta', year: '2017' },
      { degree: 'Magister Sains (M.Si.)', institution: 'Universitas Trisakti Jakarta', year: '2007' },
      { degree: 'Magister Manajemen (M.M.)', institution: 'Universitas Trisakti Jakarta', year: '2005' },
      { degree: 'Sarjana Ekonomi (S.E.)', institution: 'Universitas Sebelas Maret (UNS) Surakarta', year: '1996' },
    ],
    career: [
      { role: 'Anggota Dewan Pengawas', org: 'BPKH', period: '2022-sekarang' },
      { role: 'Dosen Fakultas Ekonomi dan Bisnis', org: 'Universitas Bhayangkara Jakarta Raya', period: '2019-sekarang' },
      { role: 'Kepala Divisi PT HK Realtindo', org: 'PT Hutama Karya (Persero) - BUMN', period: '2021-2022' },
      { role: 'Direktur Utama', org: 'PT Jasa Sarana - Holding Company BUMD Provinsi', period: '2016-2018' },
      { role: 'Komisaris', org: 'PT Marga Sarana Jabar (PT Jasa Marga Tbk) - BUMN', period: '2016-2018' },
      { role: 'General Manager', org: 'PT Krakatau Bandar Samudera (PT Krakatau Steel Tbk) - BUMN', period: '2010-2016' },
    ],
    expertise: ['Accountability', 'Public Finance', 'Accounting', 'Economics', 'Governance', 'Transparency', 'Corporate Management'],
    bio: 'Dr. H. Mulyadi adalah Anggota Dewan Pengawas BPKH periode 2022-2027, diangkat berdasarkan Keputusan Presiden RI No. 101/P Tahun 2022. Warga negara Indonesia berdomisili di Cilegon. Perjalanan akademis dan profesionalnya meliputi akuntansi, ekonomi, dan tata kelola. Meraih gelar Doktor Ilmu Ekonomi dari Universitas Trisakti, Dr. Mulyadi memiliki pengalaman luas di berbagai BUMN besar termasuk sebagai Direktur Utama PT Jasa Sarana, Komisaris PT Marga Sarana Jabar, dan General Manager di PT Krakatau Bandar Samudera. Tidak memiliki hubungan afiliasi dengan Anggota Badan Pelaksana dan Anggota Dewan Pengawas lainnya.',
    quote: 'Dana haji adalah amanah yang harus ditangani dengan integritas tertinggi.',
  },
  {
    slug: 'muhammad-dawud-arif-khan',
    name: 'Dr. H. M. Dawud Arif Khan, S.E., M.Si., Ak., CPA., QIA., QGIA.',
    shortName: 'Muhammad Dawud Arif Khan',
    title: 'Anggota Dewan Pengawas BPKH',
    titleEn: 'Supervisory Board Member, BPKH',
    photo: 'https://bpkh.go.id/storage/uploads/2016/06/M.-Dawud-Arif-Khan.png',
    bpkhUrl: 'https://bpkh.go.id/tentang-bpkh/biodata/dewan-pengawas/m-dawud-arif-khan',
    domicile: 'Tangerang Selatan',
    period: '2022-2027',
    affiliations: ['BPKH (Badan Pengelola Keuangan Haji)', 'UIN Syarif Hidayatullah Jakarta', 'Dewan Syariah Nasional MUI', 'Bank Indonesia'],
    education: [
      { degree: 'Program Doktor Ekonomi Islam', institution: 'UIN Syarif Hidayatullah Jakarta', year: '2011-2016' },
      { degree: 'Magister Akuntansi', institution: 'Universitas Muhammadiyah Jakarta', year: '2002-2005' },
      { degree: 'D4 Akuntansi', institution: 'Sekolah Tinggi Akuntansi Negara (STAN)', year: '1995-1998' },
      { degree: 'S1 Manajemen', institution: 'Universitas Terbuka', year: '1992-1996' },
      { degree: 'D3 Akuntansi', institution: 'Sekolah Tinggi Akuntansi Negara (STAN)', year: '1989-1992' },
    ],
    career: [
      { role: 'Anggota Dewan Pengawas', org: 'BPKH', period: '2022-sekarang' },
      { role: 'Wakil Bendahara Dewan Syariah Nasional', org: 'MUI', period: '2020-sekarang' },
      { role: 'Anggota Dewan Standar Akuntansi Syariah (DSAS)', org: 'IAI', period: '2020-sekarang' },
      { role: 'Komite Kebijakan Akuntansi Keuangan', org: 'Bank Indonesia', period: '2018-sekarang' },
      { role: 'Asesor LSP', org: 'MUI', period: '2017-sekarang' },
    ],
    expertise: ['Islamic Economics', 'Sharia Accounting', 'Fatwa Studies', 'Sharia Governance', 'CPA & QIA', 'Financial Auditing'],
    bio: 'Dr. H. M. Dawud Arif Khan adalah Anggota Dewan Pengawas BPKH periode 2022-2027, diangkat berdasarkan Keputusan Presiden RI No. 101/P Tahun 2022. Warga negara Indonesia berdomisili di Tangerang Selatan. Meraih gelar Doktor Ekonomi Islam dari UIN Syarif Hidayatullah Jakarta, keahliannya mencakup akuntansi syariah, studi fatwa, dan tata kelola syariah kontemporer. Saat ini juga menjabat sebagai Wakil Bendahara Dewan Syariah Nasional MUI, Anggota Dewan Standar Akuntansi Syariah, dan Komite Kebijakan Akuntansi Keuangan Bank Indonesia. Tidak memiliki hubungan afiliasi dengan Anggota Badan Pelaksana dan Anggota Dewan Pengawas lainnya.',
    quote: 'Inovasi tetap dalam batas-batas etis syariah bukan sebagai kendala, tetapi sebagai kompas.',
  },
];

export const AUTHOR_NAME_TO_SLUG = {};
AUTHORS.forEach(a => { AUTHOR_NAME_TO_SLUG[a.shortName] = a.slug; });
AUTHOR_NAME_TO_SLUG['Muhammad Arief Mufraini'] = 'arif-mufraini';
AUTHOR_NAME_TO_SLUG['Muhammad Dawud Arif Khan'] = 'muhammad-dawud-arif-khan';

const AuthorPage = () => {
  const { authorSlug } = useParams();
  const { lang } = useTranslation();
  const author = AUTHORS.find(a => a.slug === authorSlug);
  const [translated, setTranslated] = useState(null);
  const [translating, setTranslating] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, [authorSlug]);

  // Translate dynamic author content when language changes
  useEffect(() => {
    if (!author || lang === 'id') {
      setTranslated(null);
      return;
    }
    let cancelled = false;
    const doTranslate = async () => {
      setTranslating(true);
      const texts = { bio: author.bio, quote: author.quote, title: author.title };
      author.education.forEach((edu, i) => {
        texts[`edu_deg_${i}`] = edu.degree;
        texts[`edu_inst_${i}`] = edu.institution;
      });
      author.career.forEach((c, i) => {
        texts[`car_role_${i}`] = c.role;
        texts[`car_org_${i}`] = c.org;
      });
      author.expertise.forEach((exp, i) => { texts[`exp_${i}`] = exp; });
      author.affiliations.forEach((aff, i) => { texts[`aff_${i}`] = aff; });
      try {
        const res = await axios.post(`${BACKEND_URL}/api/translate/batch`, { texts, target_lang: lang });
        if (!cancelled) setTranslated(res.data.translations);
      } catch {}
      if (!cancelled) setTranslating(false);
    };
    doTranslate();
    return () => { cancelled = true; };
  }, [lang, authorSlug]); // eslint-disable-line react-hooks/exhaustive-deps

  const gt = (key, fallback) => (translated && translated[key]) || fallback;

  if (!author) {
    return (
      <div className="blog-page">
        <div className="article-not-found">
          <h2>{t('author_not_found')}</h2>
          <Link to="/buku" className="blog-back-link"><ArrowLeft size={18} /> {t('nav_buku')}</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-page" data-testid="author-page">
      <header className="main-header">
        <div className="header-container">
          <div className="header-logo">
            <BookOpen size={32} />
            <div className="logo-text">
              <span className="logo-title">Atomic Habits</span>
              <span className="logo-subtitle">for Sharia Bankers</span>
            </div>
          </div>
          <nav className="header-nav">
            <Link to="/" className="nav-link"><Home size={18} /> {t('lp_nav_home')}</Link>
            <Link to="/buku" className="nav-link"><BookOpen size={18} /> {t('nav_buku')}</Link>
          </nav>
          <LanguagePicker />
        </div>
      </header>

      <div className="author-profile" data-testid="author-profile">
        <div className="author-profile-inner">
          <Link to="/buku" className="blog-back-link" data-testid="author-back-link">
            <ArrowLeft size={18} /> {t('nav_buku')}
          </Link>

          <div className="author-hero">
            <div className="author-photo-wrapper">
              <img src={author.photo} alt={author.shortName} className="author-photo" data-testid="author-photo" />
            </div>
            <div className="author-hero-info">
              <h1 className="author-name" data-testid="author-name">{author.name}</h1>
              <p className="author-title-role" data-testid="author-title">{gt('title', author.title)}</p>
              <p className="author-meta-info">{t('author_domicile')}: {author.domicile} &middot; {t('author_period')}: {author.period}</p>
              <div className="author-affiliations">
                {author.affiliations.map((aff, i) => (
                  <span key={i} className="author-affiliation-badge"><Briefcase size={14} /> {gt(`aff_${i}`, aff)}</span>
                ))}
              </div>
              {author.bpkhUrl && (
                <a href={author.bpkhUrl} target="_blank" rel="noopener noreferrer" className="author-bpkh-link" data-testid="author-bpkh-link">
                  <ExternalLink size={14} /> {t('author_view_bpkh')}
                </a>
              )}
            </div>
          </div>

          {translating && (
            <div className="author-translating" data-testid="author-translating">
              <Loader size={16} className="spin-icon" /> {t('author_translating')}
            </div>
          )}

          <blockquote className="author-quote" data-testid="author-quote">
            <span className="quote-mark">&ldquo;</span>{gt('quote', author.quote)}<span className="quote-mark">&rdquo;</span>
          </blockquote>

          <section className="author-section">
            <h2 className="author-section-title"><Users size={22} /> {t('author_biography')}</h2>
            <p className="author-bio-text" data-testid="author-bio">{gt('bio', author.bio)}</p>
          </section>

          <section className="author-section">
            <h2 className="author-section-title"><GraduationCap size={22} /> {t('author_education')}</h2>
            <div className="author-timeline" data-testid="author-education">
              {author.education.map((edu, i) => (
                <div key={i} className="timeline-item">
                  <div className="timeline-dot" />
                  <div className="timeline-content">
                    <h4 className="timeline-title">{gt(`edu_deg_${i}`, edu.degree)}</h4>
                    <p className="timeline-subtitle">{gt(`edu_inst_${i}`, edu.institution)}</p>
                    {edu.year && <span className="timeline-year">{edu.year}</span>}
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="author-section">
            <h2 className="author-section-title"><Briefcase size={22} /> {t('author_career')}</h2>
            <div className="author-timeline" data-testid="author-career">
              {author.career.map((c, i) => (
                <div key={i} className="timeline-item">
                  <div className="timeline-dot" />
                  <div className="timeline-content">
                    <h4 className="timeline-title">{gt(`car_role_${i}`, c.role)}</h4>
                    <p className="timeline-subtitle">{gt(`car_org_${i}`, c.org)}</p>
                    <span className="timeline-year">{c.period}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="author-section">
            <h2 className="author-section-title"><Award size={22} /> {t('author_expertise')}</h2>
            <div className="author-expertise-tags" data-testid="author-expertise">
              {author.expertise.map((exp, i) => (
                <span key={i} className="expertise-tag">{gt(`exp_${i}`, exp)}</span>
              ))}
            </div>
          </section>

          <section className="author-section">
            <h2 className="author-section-title"><Users size={22} /> {t('author_other_authors')}</h2>
            <div className="other-authors-grid">
              {AUTHORS.filter(a => a.slug !== authorSlug).map(a => (
                <Link to={`/penulis/${a.slug}`} key={a.slug} className="other-author-card" data-testid={`other-author-${a.slug}`}>
                  <img src={a.photo} alt={a.shortName} className="other-author-photo" />
                  <div className="other-author-info">
                    <h4>{a.shortName}</h4>
                    <p>{a.title}</p>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        </div>
      </div>

      <footer className="blog-footer">
        <div className="blog-footer-inner">
          <p>&copy; 2026 {t('footer_copyright')}</p>
        </div>
      </footer>
    </div>
  );
};

export default AuthorPage;
